function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M103.41 58.29L708.01 58.29L708.01 258.29L103.41 258.29L103.41 58.29Z",
  id: "d2joNMZmYP"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.86 192.91L187.64 192.91L187.64 202.91L25.86 202.91L25.86 192.91Z",
  id: "bar1-path"
});

var _ref4 = /*#__PURE__*/React.createElement("tspan", {
  x: 181.31,
  dy: "0em",
  alignmentBaseline: "before-edge",
  dominantBaseline: "text-before-edge",
  textAnchor: "start"
}, "tepedu");

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M187.64 192.91L619.08 192.91L619.08 202.91L187.64 202.91L187.64 192.91Z",
  id: "bar2-path"
});

var _ref6 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n        #first-bar-instance { /* Was blue-bar-instance */\n            transform-origin: left center;\n            transform: scaleX(0);\n            opacity: 0;\n            animation: drawBarFirst 0.5s ease-out forwards;\n        }\n\n        #second-bar-instance { /* Was pink-bar-instance */\n            transform-origin: left center;\n            transform: scaleX(0);\n            opacity: 0;\n            animation: drawBarSecond 0.7s ease-out 0.45s forwards; /* Start after first bar */\n        }\n\n        #text-group-instance {\n            opacity: 0;\n            animation: fadeInText 0.6s ease-out 0.95s forwards; /* Start after second bar starts drawing */\n        }\n\n        @keyframes drawBarFirst {\n            to {\n                transform: scaleX(1);\n                opacity: 1;\n            }\n        }\n\n        @keyframes drawBarSecond {\n            to {\n                transform: scaleX(1);\n                opacity: 1;\n            }\n        }\n\n        @keyframes fadeInText {\n            to {\n                opacity: 1;\n            }\n        }\n    ");

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d2joNMZmYP",
  opacity: 1,
  fill: "#000000",
  fillOpacity: 0
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  id: "first-bar-instance",
  xlinkHref: "#bar1-path",
  opacity: 1,
  fill: "#AAAAAA",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "text-group-instance"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#text-tepedu-def",
  opacity: 1,
  fill: "#CCCCCC",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#text-tepedu-def",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#82e657",
  strokeWidth: 0,
  strokeOpacity: 1
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  id: "second-bar-instance",
  xlinkHref: "#bar2-path",
  opacity: 1,
  fill: "#3333333",
  fillOpacity: 1
}))));

const SvgTepedu300 = (_ref) => {
  let {
    svgRef
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 650 230",
    width: 650,
    height: 230,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, _ref2, _ref3, /*#__PURE__*/React.createElement("text", {
    id: "text-tepedu-def",
    x: 181.31,
    y: 276.57,
    fontSize: 168,
    fontFamily: "IBM Plex Mono, monospace",
    fontWeight: "normal",
    fontStyle: "normal",
    letterSpacing: 0,
    alignmentBaseline: "before-edge",
    transform: "matrix(1 0 0 1 -161.3885168693248 -297.0950624560328)",
    style: {
      lineHeight: "100%"
    },
    xmlSpace: "preserve",
    dominantBaseline: "text-before-edge"
  }, _ref4), _ref5, _ref6), _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTepedu300, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tepedu300.a910a5b9.svg";
export { ForwardRef as ReactComponent };